import { unescape } from 'lodash'
import { appContext } from '../viewer-app-module/DataBindingAppContext'

export const convertOldComponentToNew = (component) => {
  const accessibilityHack = initAccessibilityHack(component)

  const newComponent = {
    id: component.uniqueId,
    setData: (data) => {
      const { connectionConfig: { properties = {} } } = component
      const propsWithNesting = []

      for (const prop of Object.keys(properties)) {
        if (prop.includes('.')) {
          const parentProps = prop.split('.').slice(0, -1)
          for (const parentProp of parentProps) {
            if (!propsWithNesting.includes(parentProp)) {
              propsWithNesting.push(parentProp)
            }
          }
        }
      }

      const propErrors = setDataToComponent({ component, data, propsWithNesting })

      if (propErrors.length > 0) {
        const { errors, props } = propErrors.reduce((acc, [prop, error]) => ({
          errors: [...acc.errors, error],
          props: [...acc.props, prop],
        }), { errors: [], props: [] })
        throw new AggregateError(errors, `Failed to set properties: ${props.join(', ')}`)
      }
    },
    bind: () => {

    },
    execute: (command, ...args) => {
      component[command](...args)
      applyAccessibilityHack(accessibilityHack, component, command)
    },
  }
  return newComponent
}

const setDataToComponent = ({ component, data, propsWithNesting, propErrors = [], parentProp = '' }) => {
  for (const [prop, value] of Object.entries(data)) {
    const propPath = parentProp ? `${parentProp}.${prop}` : prop
    if (propsWithNesting.includes(prop)) {
      setDataToComponent({
        propsWithNesting, propErrors,
        data: value,
        component: component[prop],
        parentProp: propPath,
      })
    } else if (prop === '_hack_link') { // $link is created by the connection adapter exactly for this hack
      putLinkToTheDeepestChild(component, value)
    } else {
      try {
        component[prop] = value
      } catch (error) {
        propErrors.push([propPath, error])
      }
    }
  }

  return propErrors
}

const putLinkToTheDeepestChild = (component, link) => {
  component.text = link
  const { html } = component
  component.text = ''
  component.html = unescape(html)
}

const initAccessibilityHack = (component) => {
  if (appContext.features.accessibilityBindings && component.connectionConfig.behaviors?.length > 0) {
    const originalHtml = component.html
    const originalHtmlHiddenFromAccessibilityTree = `<div aria-hidden="true">${originalHtml}</div>`
    component.html = originalHtmlHiddenFromAccessibilityTree
    component.accessibility.ariaLive = 'polite'
    const announcement = { state: { type: 'untriggered' } }
    return {
      originalHtml,
      originalHtmlHiddenFromAccessibilityTree,
      announcement,
    }
  }
  return undefined
}

const applyAccessibilityHack = (accessibilityHack, component, command) => {
  if (accessibilityHack) {
    const { originalHtml, originalHtmlHiddenFromAccessibilityTree, announcement } = accessibilityHack
    if (command === 'show') {
      if (announcement.state.type === 'untriggered') {
        const timerId = setTimeout(() => {
          component.html = `${originalHtmlHiddenFromAccessibilityTree}<div style="height:0;width:0;overflow:hidden">${originalHtml}</div>`
          announcement.state = { type: 'triggered' }
        }, 150)
        announcement.state = { type: 'pendingTriggering', timerId }
      }
    } else if (command === 'hide') {
      if (announcement.state.type === 'pendingTriggering') {
        clearTimeout(announcement.state.timerId)
        announcement.state = { type: 'untriggered' }
      } else {
        component.html = originalHtmlHiddenFromAccessibilityTree
      }
    }
  }
}
